<script>
	import { createEventDispatcher } from 'svelte';
	import { fade } from 'svelte/transition';
	import Identity from 'svelte-key'
	import { person, logOut, helpCircleOutline, expand, addCircleOutline, settings as settingsIcon, cube, map, headset, videocam, document, link, bookmark, refresh, image, grid, download, informationCircleOutline } from 'ionicons/icons/index.mjs';
	import { sortByName, ignoreCaseSort } from '../shared/utils/Sort.svelte'
	import { search, fetchData, getLocalServer } from '../shared/utils/Data.svelte'
	import Node from '../shared/sidebar/Node.svelte';

	export let vitals;
	export let sceneId;
	export let scene;
	export let keys;
	export let settings;
	export let isPublic;
	export let hasSearch;
	export let tooltips;
	let items = [];

	const dispatch = createEventDispatcher();
	function sendMessage(message) {
		dispatch('message', message);
	}
		
	function searchHandler(e) {
			if (e.key === "Enter") {
					items = search(e.target.value, "name");
			}
	}

	function clickHandler(feature) {
		sendMessage({
				type: "annotation",
				data: {
					feature: feature,
					projection: scene.projection
				}
		})
	}
</script>

<div id="tree" class="panel">
	<div class="panel-body">
		{#if scene && hasSearch}
			<div class="tile tile-centered pl-2 pr-2">
				<div class="tile-content">
					<div class="divider" data-content="ANNOTATIONS"></div>
				</div>
			</div>
			<div class="container">
				<div class="tile tile-centered">
						<div class="tile-content">
								<div class="form-group pb-1">
										<input class="form-input" type="text" autocomplete="off" id="search" on:keyup={searchHandler} placeholder="Search">
								</div>
						</div>
				</div>
				{#each items as item}
						<div class="tile tile-centered">
								<div class="tile-content search-title">
										<div class="tile-title">{ item.properties["name"] }</div>
								</div>
								<div class="tile-action search-action">
										<button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View" on:click|stopPropagation={(e) => {
																e.currentTarget.blur();
																clickHandler(item);
														}}>
												<i class="svg">{@html expand.md}</i>
										</button>
								</div>
						</div>
				{/each}
			</div>
		{/if}
		{#if scene && scene.project != "global"}
			<div class="tile tile-centered pl-2">
				<div class="tile-content">
					<div class="divider" data-content="PROJECT MEDIA"></div>
				</div>
				<div class="tile-action">
					{#if scene.role > 1}
						<button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Add Media" on:click={(e) => {
							e.currentTarget.blur();
								sendMessage({
									type: "modal",
									data: {
										view: "mediaUpload",
										id: scene.project
									}
								})
							}}>
							<i class="svg">{@html addCircleOutline.md}</i>
						</button>
					{/if}
				</div>
			</div>
			<Identity key={keys.project}>
				{#if scene != ""}
					{#if Object.keys(scene.media.project).length > 0}
						{#each Object.keys(scene.media.project).sort(ignoreCaseSort) as section}
							<div class="accordion" in:fade>
								<input type="checkbox" id={"project-" + section} name="accordion-checkbox" hidden>
								<label class="accordion-header" for={"project-" + section}>
									<div class="tile tile-centered">
										<div class="tile-icon">
											<div class="example-tile-icon">
											<i class="icon icon-arrow-right centered"></i>
											</div>
										</div>
										<div class="tile-content">
											<div class="tile-title">{section}</div>
										</div>
									</div>    
								</label>
								<div class="accordion-body">
									<ul class="menu menu-nav">
										{#if Object.values(scene.media.project[section]).length > 0}
											{#each Object.values(scene.media.project[section]).sort(sortByName) as item}
												<div class="tile tile-centered">
													<div class="tile-icon">
														<div class="type-icon">
															{#if item.type == "link"}
																<i class="svg">{@html link.md}</i>
															{:else if item.type == "download"}
																<i class="svg">{@html download.md}</i>
															{:else if item.type == "pdf" || item.type == "document"}
																<i class="svg">{@html bookmark.md}</i>
															{:else if item.type == "image"}
																<i class="svg">{@html image.md}</i>
															{:else if item.type == "360"}
																<i class="svg">{@html refresh.md}</i>
															{:else if item.type == "audio"}
																<i class="svg">{@html headset.md}</i>
															{:else if item.type == "video"}
																<i class="svg">{@html videocam.md}</i>
															{:else}
																<i class="svg">{@html document.md}</i>
															{/if}
														</div>
													</div>
													<div class="tile-content">
														<li class="menu-item">
															{#if settings.newTab && (item.type == "link" || item.type == "pdf")}
																<a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
															{:else if item.type == "download"}
																{#if window.platform == "Windows"}
																	<button class="btn btn-link" on:click|stopPropagation={async (e) => {
																		e.currentTarget.blur();
																		let [res, err]  = await fetchData(getLocalServer() + "/core", {
																			method: "POST",
																			headers: {
																					'Accept': 'application/json',
																					'Content-Type': 'application/json'
																			},
																			body: JSON.stringify({
																				url: item.uri
																			})
																		});
																		if (err || !res.found) {
																				window.open(item.uri, "_blank");
																		}
																	}}>
																	{item.name}
																	</button>
																{:else}
																	<a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
																{/if}
															{:else}
																<button class="btn btn-link"
																on:click|stopPropagation={(e) => {
																	e.currentTarget.blur();
																	sendMessage({
																		type: "modal",
																		data: {
																			view: "mediaView",
																			media: item
																		}
																	})
																}}>{item.name}</button>
															{/if}
														</li>
													</div>
													<div class="tile-action">
														<button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Details" on:click|stopPropagation={(e) => {
																	e.currentTarget.blur();
																	sendMessage({
																		type: "modal",
																		data: {
																			view: "mediaUpload",
																			id: scene.project,
																			group: section,
																			media: item
																		}
																	})
																}}>
															<i class="svg">{@html informationCircleOutline.md}</i>
														</button>
													</div>
												</div>
											{/each}
										{/if}
									</ul>
								</div>
							</div>
						{/each}
					{/if}
				{/if}
			</Identity>
		{/if}
		<div class="tile tile-centered pl-2">
			<div class="tile-content">
				<div class="divider" data-content="SCENE MEDIA"></div>
			</div>
			<div class="tile-action">
				{#if scene.role > 1}
					<button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Add Media" on:click={(e) => {
							e.currentTarget.blur();
							sendMessage({
								type: "modal",
								data: {
									view: "mediaUpload",
									id: scene.media_id
								}
							})
						}}>
						<i class="svg">{@html addCircleOutline.md}</i>
					</button>
				{/if}
			</div>
		</div>
		<Identity key={keys.scene}>
			{#if scene != ""}
				{#if Object.keys(scene.media.scene).length > 0}
					{#each Object.keys(scene.media.scene).sort(ignoreCaseSort) as section}
						<div class="accordion" in:fade>
							<input type="checkbox" id={"scene-" + section} name="accordion-checkbox" hidden>
							<label class="accordion-header" for={"scene-" + section}>
								<div class="tile tile-centered">
									<div class="tile-icon">
										<div class="example-tile-icon">
										<i class="icon icon-arrow-right centered"></i>
										</div>
									</div>
									<div class="tile-content">
										<div class="tile-title">{section}</div>
									</div>
								</div>    
							</label>
							<div class="accordion-body">
								<ul class="menu menu-nav">
									{#if Object.values(scene.media.scene[section]).length > 0}
										{#each Object.values(scene.media.scene[section]).sort(sortByName) as item}
											<div class="tile tile-centered">
												<div class="tile-icon">
													<div class="type-icon">
														{#if item.type == "link"}
															<i class="svg">{@html link.md}</i>
														{:else if item.type == "download"}
															<i class="svg">{@html download.md}</i>
														{:else if item.type == "pdf" || item.type == "document"}
															<i class="svg">{@html bookmark.md}</i>
														{:else if item.type == "image"}
															<i class="svg">{@html image.md}</i>
														{:else if item.type == "360"}
															<i class="svg">{@html refresh.md}</i>
														{:else if item.type == "audio"}
															<i class="svg">{@html headset.md}</i>
														{:else if item.type == "video"}
															<i class="svg">{@html videocam.md}</i>
														{:else}
															<i class="svg">{@html document.md}</i>
														{/if}
													</div>
												</div>
												<div class="tile-content">
													<li class="menu-item">
														{#if settings.newTab && (item.type == "link" || item.type == "pdf")}
															<a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
														{:else if item.type == "download"}
															{#if window.platform == "Windows"}
																<button class="btn btn-link" on:click|stopPropagation={async (e) => {
																	e.currentTarget.blur();
																	let [res, err]  = await fetchData(getLocalServer() + "/core", {
																		method: "POST",
																		headers: {
																				'Accept': 'application/json',
																				'Content-Type': 'application/json'
																		},
																		body: JSON.stringify({
																			url: item.uri
																		})
																	});
																	if (err || !res.found) {
																			window.open(item.uri, "_blank");
																	}
																}}>
																{item.name}
																</button>
															{:else}
																<a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
															{/if}
														{:else}
															<button class="btn btn-link"
															on:click|stopPropagation={(e) => {
																e.currentTarget.blur();
																sendMessage({
																	type: "modal",
																	data: {
																		view: "mediaView",
																		media: item
																	}
																})
															}}>{item.name}</button>
														{/if}
													</li>
												</div>
												<div class="tile-action">
													<button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Details" on:click|stopPropagation={(e) => {
															e.currentTarget.blur();
															sendMessage({
																type: "modal",
																data: {
																	view: "mediaUpload",
																	id: scene.media_id,
																	group: section,
																	media: item
																}
															})
														}}>
														<i class="svg">{@html informationCircleOutline.md}</i>
													</button>
												</div>
											</div>
										{/each}
									{/if}
								</ul>
							</div>
						</div>
					{/each}
				{/if}
			{/if}
		</Identity>
		<div class="tile tile-centered pr-2 pl-2">
			<div class="tile-content">
				<div class="divider" data-content="PROJECT TREE"></div>
			</div>
		</div>
		<Identity key={keys.tree}>
			{#if scene != ""}
				{#if Object.keys(scene.tree).length > 0}
					{#each Object.keys(scene.tree) as section}
						{#if section != "tables"}
							{#if scene.tree[section].child_count == 0}
									<ul class="menu menu-nav">
											<div class="tile tile-centered">
													<div class="tile-content tile-tree">
															<li class="menu-item {sceneId == scene.tree[section].id ? "active" : ""}">{scene.tree[section].name}</li>
													</div>
													<div class="tile-action">
															{#if scene.tree[section].type == "map"}
																	<a href={isPublic ? "/maps/" + scene.tree[section].id + "?public" : "/maps/" + scene.tree[section].id} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Map">
																			<i class="svg">{@html map.md}</i>
																	</a>
															{:else if scene.tree[section].type == "scene"}
																	<a href={isPublic ? "/scenes/" + scene.tree[section].id + "?public" : "/scenes/" + scene.tree[section].id} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Scene">
																			<i class="svg">{@html cube.md}</i>
																	</a>
															{:else if scene.tree[section].type == "table"}
																		<a href={isPublic ? "/tables/" + scene.tree[section].id + "?public" : "/tables/" + scene.tree[section].id} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Table">
																				<i class="svg">{@html grid.md}</i>
																		</a>
																{/if}
													</div>
											</div>
									</ul>
							{:else}
									<Node sceneId={sceneId} node={scene.tree[section]} isPublic={isPublic} />
							{/if}
						{/if}
					{/each}
					{#if scene.tree.tables && scene.tree.tables.length > 0}
							<div class="tile tile-centered pr-2 pl-2">
											<div class="tile-content">
															<div class="divider" data-content="TABLES"></div>
											</div>
							</div>
							{#each scene.tree.tables as table}
									<ul class="menu menu-nav">
											<div class="tile tile-centered">
													<div class="tile-content tile-tree">
																	<li class="menu-item">{table.name}</li>
													</div>
													<div class="tile-action">
															<a href={isPublic ? "/tables/" + table.id + "?public" : "/tables/" + table.id} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Table">
																	<i class="svg">{@html grid.md}</i>
															</a>
													</div>
											</div>
									</ul>
							{/each}
					{/if}
				{/if}
			{/if}
		</Identity>
	</div>
	<div class="panel-footer">
		<div class="tile tile-centered">
			<div class="tile-content">
				<div class="btn-group slant slant-right-reverse">
					{#if isPublic}
						<a class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" href={"/?p=" + scene.project + "&public"} data-tooltip="Dashboard"><i class="svg svg-light">{@html person.md}</i></a>
					{:else}
						<a class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" href="/" data-tooltip="Dashboard"><i class="svg svg-light">{@html person.md}</i></a>
					{/if}
					<button class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Settings" on:click={(e) => {
					e.currentTarget.blur();
					sendMessage({
						type: "modal",
						data: {
								view: "settings"
						}
					})
					}}><i class="svg svg-light">{@html settingsIcon.md}</i></button>
					<button class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Sign Out" on:click={(e) => {
					e.currentTarget.blur();
					sendMessage({
						type: "session",
						data: {
							workspaces: ""
						}
					})
					}}><i class="svg svg-light">{@html logOut.md}</i></button>
					<button class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Help" on:click={async (e) => {
						e.currentTarget.blur();
						if (window.platform == "Windows") {
							await fetch(getLocalServer() + "/help")
						}
						else {
							window.open("https://www.ztools.geosync.cloud/forum/geosync-app");
						}
					}}><i class="svg svg-light">{@html helpCircleOutline.md}</i></button>
				</div>
			</div>
			<div class="tile-action version">
					{ vitals.version }
			</div>
		</div>
	</div>
</div>

<style>
	.version {
		font-size: 80%;
		margin-top: 15px;
		margin-right: 5px;
	}
    #tree {
        position: fixed;
        overflow-y: auto;
        width: 300px;
        height: 100%;
	}
	.panel {
        border: 0;
	}
	.panel .panel-body {
		padding: 0;
    }
	.panel .panel-footer {
		padding: 0;
		background: #efefef;
	}
	.accordion .accordion-header {
		cursor: pointer;
		user-select: none;
		height: 1rem;
		padding: 0.2rem 0rem 0.2rem 0.75rem;
	}
	.accordion-body {
		padding-left: 1rem;
        margin: 0.4rem 0 0 0;
	}
	.menu {
        padding: 0 0 0 0.8rem;
    }
    .menu .menu-item {
        padding: 0;
    }
	.menu .menu-item > button {
		border: 0;
	}
	::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
	}
	.menu-item a {
		text-align: left;
		padding-left: 1rem;
	}
	.menu-item a:hover, .menu-item a:visited {
		background-color: transparent;
	}
	.menu .menu-item > a:focus, .menu .menu-item > a:hover {
		background-color: transparent;
	}
	.menu-item.active {
		color: #00ab5f;
	}
	.type-icon {
		display: inline-block;
		font-size: 0.8rem;
		height: 1.8rem;
		width: 1.8rem;
		line-height: 1.2rem;
		outline: none;
		padding: 0.25rem 0.4rem;
		text-align: center;
	}
	
	::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
	}
	.menu-item.active {
		color: #00ab5f;
	}
	.svg {
		fill: #00ab5f;
	}
	.slant {
		color: white;
		background-color: #00ab5f;
		transform-origin: bottom left;
		position: relative;
		z-index: 1;
	}
	.slant-right-reverse:before {
		content: "";
		position: absolute;
		z-index: -1;
		top: 0;
		bottom: 0;
		right: 0;
		width: 20px;
		margin-right: -10px;
		background-color: #00ab5f;
		border-right: 2px solid #a9d9bb;
		-ms-transform: skew(30deg, 0deg);
		-webkit-transform: skew(30deg, 0deg);
		transform: skew(30deg, 0deg);
	}
	.slant .btn.btn-link {
		color: white;
	}
	.form-group {
        margin: 0.2rem 0;
    }
		.search-action .btn {
			padding: 0;
		}
	.search-title {
		padding-left: 0.4rem;
	}
</style>
